export function installDirectives(app) {
  // Самописная директива v-scroll-el: вешает на элемент обработчик скролла элемента
  app.directive('scroll-el', {
    mounted(el, binding) {
      const f = function(evt) {
        if (binding.value(evt, el)) {
          el.removeEventListener('scroll', f, {passive: true});
          return;
        }
        binding.value(evt, el);
      };
      el._scrollElHandler = f;
      el.addEventListener('scroll', f, {passive: true});
    },
    unmounted(el) {
      if (el._scrollElHandler) {
        el.removeEventListener('scroll', el._scrollElHandler, {passive: true});
      }
    },
  });

  // v-click-outside ожидает в значении ссылку на метод
  app.directive('click-outside', {
    mounted(el, binding) {
      el.clickOutsideEvent = function(event) {
        // here I check that click was outside the el and his children
        if (!(el === event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          binding.value(event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    },
  });
}
